export function isBrowser() {
  return !(typeof window === 'undefined');
}

export function isMobile() {
  if (isBrowser()) {
    return window.innerWidth < 992;
  }

  return false;
}
